import axios from 'axios';
import { urlAuth } from '../utils';

export const apiAuth = axios.create({
    baseURL: `${urlAuth}`
});